// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Traffic Config API
 * traffic-config-api manages traffic configuration for the Aura platform.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TrafficconfigAzurePrivateEndpointState } from './TrafficconfigAzurePrivateEndpointState';
import {
  TrafficconfigAzurePrivateEndpointStateFromJSON,
  TrafficconfigAzurePrivateEndpointStateFromJSONTyped,
  TrafficconfigAzurePrivateEndpointStateToJSON,
  TrafficconfigAzurePrivateEndpointStateToJSONTyped,
} from './TrafficconfigAzurePrivateEndpointState';

/**
 *
 * @export
 * @interface TrafficconfigAzurePrivateEndpointConnection
 */
export interface TrafficconfigAzurePrivateEndpointConnection {
  /**
   *
   * @type {string}
   * @memberof TrafficconfigAzurePrivateEndpointConnection
   */
  privateEndpointId?: string;
  /**
   *
   * @type {TrafficconfigAzurePrivateEndpointState}
   * @memberof TrafficconfigAzurePrivateEndpointConnection
   */
  state?: TrafficconfigAzurePrivateEndpointState;
}

/**
 * Check if a given object implements the TrafficconfigAzurePrivateEndpointConnection interface.
 */
export function instanceOfTrafficconfigAzurePrivateEndpointConnection(
  value: object,
): value is TrafficconfigAzurePrivateEndpointConnection {
  return true;
}

export function TrafficconfigAzurePrivateEndpointConnectionFromJSON(
  json: any,
): TrafficconfigAzurePrivateEndpointConnection {
  return TrafficconfigAzurePrivateEndpointConnectionFromJSONTyped(json, false);
}

export function TrafficconfigAzurePrivateEndpointConnectionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TrafficconfigAzurePrivateEndpointConnection {
  if (json == null) {
    return json;
  }
  return {
    privateEndpointId:
      json['private_endpoint_id'] == null
        ? undefined
        : json['private_endpoint_id'],
    state:
      json['state'] == null
        ? undefined
        : TrafficconfigAzurePrivateEndpointStateFromJSON(json['state']),
  };
}

export function TrafficconfigAzurePrivateEndpointConnectionToJSON(
  json: any,
): TrafficconfigAzurePrivateEndpointConnection {
  return TrafficconfigAzurePrivateEndpointConnectionToJSONTyped(json, false);
}

export function TrafficconfigAzurePrivateEndpointConnectionToJSONTyped(
  value?: TrafficconfigAzurePrivateEndpointConnection | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    private_endpoint_id: value['privateEndpointId'],
    state: TrafficconfigAzurePrivateEndpointStateToJSON(value['state']),
  };
}
